const Backbone = require('lib/backbone')
const RelatedModel = require('./related_model')
const RelatedList = require('./related_list')
const Testimonial = require('./testimonial')
const log = require('log').create('user', 'testimonials') // eslint-disable-line

const Testimonials = RelatedModel.extend({

    id: 'testimonials',

    defaults: {
        header: '0',
        items: [],
    },

    relations: [
        {
            type: Backbone.Many,
            key: 'items',
            collectionType: RelatedList.extend({
                id: 'items',
                model: Testimonial,
            }),
        },
    ],

    set() {
        const { attrs, options } = this.parseKeyValArguments.apply(this, arguments)
        // ensure header is always a string
        if (typeof attrs.header === 'number') {
            attrs.header = attrs.header.toString()
        }
        return RelatedModel.prototype.set.apply(this, [attrs, options])
    },

    update() {
        const attrs = this.toJSON()
        return this.patch(attrs)
    },

})

module.exports = Testimonials
